var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 3.8125H4.91332C3.92026 3.8125 3.11523 4.61753 3.11523 5.61058V18.1972C3.11523 19.1902 3.92026 19.9953 4.91332 19.9953H17.4999C18.493 19.9953 19.298 19.1902 19.298 18.1972V5.61058C19.298 4.61753 18.493 3.8125 17.4999 3.8125Z",
    stroke: "white",
    strokeWidth: 1.07885,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8027 2.01953V5.6157",
    stroke: "white",
    strokeWidth: 1.07885,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60938 2.01953V5.6157",
    stroke: "white",
    strokeWidth: 1.07885,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11523 9.20703H19.298",
    stroke: "white",
    strokeWidth: 1.07885,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.6c35300579a188d28f4e8a428e669683.svg";
export { ForwardRef as ReactComponent };